var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTransactionIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4C2.67157 4 2 4.67157 2 5.5V14.5C2 15.3284 2.67157 16 3.5 16H16.5C17.3284 16 18 15.3284 18 14.5V5.5C18 4.67157 17.3284 4 16.5 4H3.5ZM6.5 10C5.67157 10 5 9.32843 5 8.5C5 7.67157 5.67157 7 6.5 7C7.32843 7 8 7.67157 8 8.5C8 9.32843 7.32843 10 6.5 10ZM4.94879 10.75H8.05121C8.57521 10.75 9 11.1748 9 11.6988C9 12.546 8.42339 13.2845 7.60144 13.49L7.54243 13.5048C6.85801 13.6759 6.14199 13.6759 5.45757 13.5048L5.39856 13.49C4.57661 13.2845 4 12.546 4 11.6988C4 11.1748 4.42479 10.75 4.94879 10.75ZM11 8.5C11 8.22386 11.2239 8 11.5 8H14.5C14.7761 8 15 8.22386 15 8.5C15 8.77614 14.7761 9 14.5 9H11.5C11.2239 9 11 8.77614 11 8.5ZM11.5 11H14.5C14.7761 11 15 11.2239 15 11.5C15 11.7761 14.7761 12 14.5 12H11.5C11.2239 12 11 11.7761 11 11.5C11 11.2239 11.2239 11 11.5 11Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransactionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/transaction-icon.fd2876ec.svg";
export { ForwardRef as ReactComponent };